import { motion } from "framer-motion";
import { VisualDataCanvas } from "@/components/triarch/VisualDataCanvas";

const LABELS = [
  "DATA STREAM",
  "UPLOAD ACTIVE",
  "INGESTION LAYER // NON-PUBLIC",
  "CONTROLLED DEVELOPMENT ENVIRONMENT",
];

export const VisualDataPanel = () => (
  <section
    id="archive"
    data-testid="visual-data-section"
    className="relative py-16 sm:py-24"
  >
    {/* 04 — label + large golden ARCHIVE heading */}
    <div className="mx-auto max-w-5xl px-5 text-center sm:px-8">
      <motion.div
        initial={{ opacity: 0, y: 14 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="mb-7 flex items-center justify-center gap-3 sm:mb-8"
      >
        <span className="h-px w-8 bg-white/15 sm:w-12" />
        <span className="font-mono-accent text-[10px] uppercase tracking-[0.3em] text-white/45">
          04
        </span>
        <span className="h-px w-8 bg-white/15 sm:w-12" />
      </motion.div>
      <motion.h2
        data-testid="archive-headline"
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, delay: 0.08, ease: [0.22, 1, 0.36, 1] }}
        className="bg-gradient-to-r from-[#b89b5e] via-[#d1b777] to-[#8f7540] bg-clip-text font-display text-4xl font-semibold uppercase tracking-[0.14em] text-transparent drop-shadow-[0_0_24px_rgba(184,155,94,0.18)] sm:text-6xl"
      >
        Archive
      </motion.h2>
    </div>

    {/* data stream animation box — central visual object */}
    <div className="mx-auto mt-10 max-w-6xl px-5 sm:mt-14 sm:px-8">
      <motion.div
        data-testid="visual-data-panel"
        initial={{ opacity: 0, y: 22 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        className="relative overflow-hidden rounded-[1.4rem] border border-white/10 bg-white/[0.03] backdrop-blur-xl shadow-[0_24px_80px_rgba(0,0,0,0.5)]"
      >
        <div className="flex flex-wrap items-center justify-between gap-3 border-b border-white/[0.06] px-6 py-4">
          <div className="flex items-center gap-2.5">
            <span className="relative flex h-1.5 w-1.5">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-[#C4A061]/40" />
              <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-[#C4A061]/80" />
            </span>
            <span
              data-testid="visual-data-label"
              className="font-mono-accent text-[10px] uppercase tracking-[0.25em] text-white/70"
            >
              {LABELS[0]}
            </span>
          </div>
          <div className="hidden items-center gap-6 sm:flex">
            <span
              data-testid="visual-data-label"
              className="font-mono-accent text-[10px] uppercase tracking-[0.25em] text-[#C9AE78]/70"
            >
              {LABELS[1]}
            </span>
            <span
              data-testid="visual-data-label"
              className="font-mono-accent text-[10px] uppercase tracking-[0.25em] text-white/35"
            >
              {LABELS[2]}
            </span>
          </div>
          <span
            data-testid="visual-data-label"
            className="font-mono-accent text-[10px] uppercase tracking-[0.25em] text-white/50"
          >
            {LABELS[3]}
          </span>
        </div>

        <div className="relative h-[320px] w-full sm:h-[420px]">
          <VisualDataCanvas />
          <div
            className="pointer-events-none absolute inset-0"
            style={{
              background:
                "radial-gradient(620px 320px at 82% 18%, rgba(203,174,120,0.07), transparent 60%)",
            }}
          />
          <div className="pointer-events-none absolute left-6 top-6 font-mono-accent text-[10px] uppercase leading-relaxed tracking-[0.22em] text-white/30">
            UPLOAD // LIVE
            <br />
            NODE-03
          </div>
          <div className="pointer-events-none absolute bottom-6 right-6 font-mono-accent text-[10px] uppercase tracking-[0.22em] text-[#C9AE78]/45">
            INGESTION ACTIVE
          </div>
        </div>
      </motion.div>
    </div>

    {/* system-status statement — beneath the animation */}
    <div className="mx-auto mt-10 max-w-5xl px-5 text-center sm:mt-14 sm:px-8">
      <motion.p
        data-testid="archive-statement"
        initial={{ opacity: 0, y: 18 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-90px" }}
        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        style={{ textWrap: "balance" }}
        className="mx-auto max-w-[820px] font-display text-[1.2rem] font-light leading-[1.4] tracking-[-0.01em] text-white/55 sm:text-[1.45rem]"
      >
        Continuous Data upload stream. Developing in a controlled development
        environment.
      </motion.p>
    </div>
  </section>
);
